import React from "react";

const TemplatePage = () => {
  return <div>Template Page</div>;
};

export default TemplatePage;
